export default function PageHeader({ titulo, subtitulo, children }) {
  return (
    <div className="d-flex align-items-center justify-content-between mb-4">
      <div>
        <h4 className="mb-0" style={{ color: 'var(--cjc-primary)' }}>{titulo}</h4>
        {subtitulo && <p className="text-muted mb-0" style={{ fontSize: 13 }}>{subtitulo}</p>}
      </div>
      {children && <div className="d-flex gap-2">{children}</div>}
    </div>
  );
}
